import {Component, ElementRef} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {EnvironmentService} from './_services/enviroment.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
})
export class AppComponent {
	public useCredilowStyle: boolean;
	title = 'Autorizador Automático';
	scripts: any;
	// El onboarding de comercios (/alta-comercio) es un flujo público
	// autocontenido con su propio header; NO debe mostrar el chrome global de
	// la app (header + menú hamburguesa). Lo ocultamos en esas rutas.
	showAppHeader = true;

	constructor(
		private readonly envService: EnvironmentService,
		private readonly router: Router,
	) {}

	ngOnInit() {
		this.updateHeaderVisibility(this.router.url);
		this.router.events
			.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
			.subscribe(e => this.updateHeaderVisibility(e.urlAfterRedirects));
	}

	private updateHeaderVisibility(url: string): void {
		this.showAppHeader = !url.startsWith('/alta-comercio');
	}
}
